export var E_PackageTag;
(function (E_PackageTag) {
    // Independent
    E_PackageTag["BASE"] = "BASE";
    // Sub independent
    E_PackageTag["SUB_INDEPENDENT"] = "SUB_INDEPENDENT";
    // Add on
    E_PackageTag["ADDON"] = "ADDON";
    // Anonymous Package
    E_PackageTag["ANONYMOUS"] = "ANONYMOUS";
    // Open API
    E_PackageTag["OPEN_API"] = "OPEN_API";
})(E_PackageTag || (E_PackageTag = {}));
// Warning: 用后端获取 !!!!
export var E_ChargeMode;
(function (E_ChargeMode) {
    // 未知
    E_ChargeMode["UNKNOWN"] = "UNKNOWN";
    // 商业
    E_ChargeMode["COMMERCIAL"] = "COMMERCIAL";
    // 使用
    E_ChargeMode["TRIAL"] = "TRIAL";
    // 免费
    E_ChargeMode["FREE"] = "FREE";
    // 历史
    E_ChargeMode["HISTORICAL"] = "HISTORICAL";
    // 内置
    E_ChargeMode["INTERNAL"] = "INTERNAL";
    // 测试
    E_ChargeMode["BETA"] = "BETA";
    // 合作推广
    E_ChargeMode["COOPERATIVE"] = "COOPERATIVE";
    // 断约
    E_ChargeMode["NOT_RENEW"] = "NOT_RENEW";
    // FREEMIUM
    E_ChargeMode["FREEMIUM"] = "FREEMIUM";
})(E_ChargeMode || (E_ChargeMode = {}));
export var E_Package_ChargeMode;
(function (E_Package_ChargeMode) {
    // 商业
    E_Package_ChargeMode["COMMERCIAL"] = "COMMERCIAL";
    // 试用
    E_Package_ChargeMode["TRIAL"] = "TRIAL";
    // 历史
    E_Package_ChargeMode["HISTORICAL"] = "HISTORICAL";
    // 内部
    E_Package_ChargeMode["INTERNAL"] = "INTERNAL";
    // 测试
    E_Package_ChargeMode["BETA"] = "BETA";
    // 合作推广
    E_Package_ChargeMode["COOPERATIVE"] = "COOPERATIVE";
    // FREEMIUM
    E_Package_ChargeMode["FREEMIUM"] = "FREEMIUM";
})(E_Package_ChargeMode || (E_Package_ChargeMode = {}));
export var E_PackageStatus;
(function (E_PackageStatus) {
    E_PackageStatus["Active"] = "Active";
    E_PackageStatus["Disable"] = "Disable";
})(E_PackageStatus || (E_PackageStatus = {}));
// 前端计算出privilege状态
export var E_PrivilegeStatus;
(function (E_PrivilegeStatus) {
    E_PrivilegeStatus["Expire"] = "Expire";
    E_PrivilegeStatus["Normal"] = "Normal";
    E_PrivilegeStatus["Disabled"] = "Disabled";
})(E_PrivilegeStatus || (E_PrivilegeStatus = {}));
export var E_PrivliegeLimitationWay;
(function (E_PrivliegeLimitationWay) {
    E_PrivliegeLimitationWay["Unlimited"] = "Unlimited";
    E_PrivliegeLimitationWay["SSO"] = "SSO";
    E_PrivliegeLimitationWay["IP_Range"] = "IP Range";
    E_PrivliegeLimitationWay["Domains"] = "Domains";
})(E_PrivliegeLimitationWay || (E_PrivliegeLimitationWay = {}));
